/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseSectionDivisionUserParser = 
/* #__PURE__ */ parsers.object([
    ['username', codecString],
    ['name', codecString],
]);
export class CourseSectionDivisionUser extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseSectionDivisionUserParser.decode(input).map(res => new CourseSectionDivisionUser(res));
    }
    static unsafeDecode(input) {
        return CourseSectionDivisionUser.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseSectionDivisionUserParser.encode(data);
    }
    static schema() {
        return CourseSectionDivisionUserParser.schema();
    }
}
